import { interopDefault } from '~/utils';
import RouteEnum from '~/enums/RouteEnum';

export default [
  {
    path: '/search',
    name: RouteEnum.SEARCH,
    component: () =>
      interopDefault(
        import(/* webpackChunkName: 'employee:search.index' */ '~/pages/employee/search/index.vue')
      ),
  },
];
